import React from "react";
import { FormHelperText } from "@mui/material";

const ErrorHelperText = ({ errorMessage, className, ...props }) => {
    return (
        <FormHelperText className={`fs-6 ${className}`}>{errorMessage}</FormHelperText>
    );
}

export default ErrorHelperText;